/* Search suggestions: "Recent searches" + "Trending now" under an empty search box. */
(function () {
  var cfg = window.nvShop || {};
  if (cfg.searchSuggest === false || !window.NvCore) return;
  var esc = window.NvCore.esc, KEY = 'nv_recent_searches_v1';

  function readRecent() { try { var a = JSON.parse(localStorage.getItem(KEY) || '[]'); return Array.isArray(a) ? a : []; } catch (e) { return []; } }
  function saveRecent(q) {
    q = String(q || '').trim().replace(/\s+/g, ' ');
    if (q.length < 2 || q.length > 60) return;
    var a = readRecent().filter(function (x) { return x.toLowerCase() !== q.toLowerCase(); });
    a.unshift(q);
    try { localStorage.setItem(KEY, JSON.stringify(a.slice(0, 8))); } catch (e) { /* private mode */ }
  }
  function trending() {
    var raw = cfg.trending || '';
    return String(raw).split(/[\n,]+/).map(function (s) { return s.trim(); }).filter(Boolean).slice(0, 10);
  }

  // remember what was searched: on submit, and when a results page is opened
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f || !f.getAttribute || !/\/search\/?$/.test(f.getAttribute('action') || '')) return;
    var i = f.querySelector('input[name="q"]');
    if (i) saveRecent(i.value);
  }, true);
  try {
    if (/\/search\/?$/.test(location.pathname)) saveRecent(new URLSearchParams(location.search).get('q'));
  } catch (e) { /* ignore */ }

  var panel = null, cur = null;
  function href(q) { return '/search?q=' + encodeURIComponent(q); }

  function build() {
    if (panel) return;
    panel = document.createElement('div');
    panel.className = 'nv-sg';
    panel.hidden = true;
    panel.addEventListener('mousedown', function (e) { e.preventDefault(); }); // keep the keyboard open while tapping chips
    panel.addEventListener('click', function (e) {
      if (e.target.closest('[data-clear]')) {
        try { localStorage.removeItem(KEY); } catch (x) { /* ignore */ }
        render(); position();
      }
    });
    document.body.appendChild(panel);
  }
  function render() {
    var rec = readRecent(), tr = trending(), h = '';
    if (rec.length) {
      h += '<div class="nv-sg__head"><span>Recent searches</span><button type="button" data-clear>Clear</button></div><div class="nv-sg__chips">';
      rec.forEach(function (q) { h += '<a class="nv-sg__chip" href="' + esc(href(q)) + '"><svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="12" cy="12" r="9"/><path d="M12 7v5l3 2"/></svg>' + esc(q) + '</a>'; });
      h += '</div>';
    }
    if (tr.length) {
      h += '<div class="nv-sg__head"><span>Trending now</span></div><div class="nv-sg__chips">';
      tr.forEach(function (q) { h += '<a class="nv-sg__chip nv-sg__chip--hot" href="' + esc(href(q)) + '"><svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="m3 17 6-6 4 4 8-8"/><path d="M14 7h7v7"/></svg>' + esc(q) + '</a>'; });
      h += '</div>';
    }
    panel.innerHTML = h;
    return !!h;
  }
  function position() {
    if (!cur || !panel || panel.hidden) return;
    var r = cur.getBoundingClientRect();
    var w = Math.max(r.width, Math.min(340, window.innerWidth - 16));
    var left = Math.min(Math.max(8, r.left), window.innerWidth - w - 8);
    panel.style.top = Math.round(r.bottom + 8) + 'px';
    panel.style.left = Math.round(left) + 'px';
    panel.style.width = Math.round(w) + 'px';
    panel.style.maxHeight = Math.max(160, Math.round(window.innerHeight - r.bottom - 24)) + 'px';
  }
  function show(input) {
    build(); cur = input;
    if (input.value.trim() || !render()) { hide(); return; }
    panel.hidden = false; position();
  }
  function hide() { if (panel) panel.hidden = true; }
  var raf = 0;
  function reposition() { cancelAnimationFrame(raf); raf = requestAnimationFrame(position); }

  function isSearchInput(el) {
    return el && el.tagName === 'INPUT' && el.name === 'q' && el.form && /\/search\/?$/.test(el.form.getAttribute('action') || '');
  }
  document.addEventListener('focusin', function (e) { if (isSearchInput(e.target)) show(e.target); });
  document.addEventListener('input', function (e) { if (isSearchInput(e.target)) { if (e.target.value.trim()) hide(); else show(e.target); } });
  document.addEventListener('focusout', function (e) { if (isSearchInput(e.target)) setTimeout(function () { if (document.activeElement !== cur) hide(); }, 120); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') hide(); });
  window.addEventListener('scroll', reposition, { passive: true });
  window.addEventListener('resize', reposition);
  if (window.visualViewport) window.visualViewport.addEventListener('resize', reposition);
})();
